import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { useSocketStore } from '../../stores/useSocketStore';
import { useAuthStore } from '../../stores/useAuthStore';
import { useScreenStore } from '../../stores/useScreenStore';
import getTabId from '../../utils/getTabId';

const socketUrl = process.env.REACT_APP_SOCKET_URL;
const TAB_ID = getTabId();

export function useSocketConnection() {

    const user = useAuthStore(state => state.user);

    useEffect(() => {

        const {screen, monitorMode} = useScreenStore.getState();

        const {
            socket,
            setSocket
        } = useSocketStore.getState();

        const shouldConnect =
            !!user &&
            monitorMode !== 0;

        if (!shouldConnect) {

            if (socket) {

                socket.disconnect();

                setSocket(null);

            }
            return;
        }

        if(socket) {
            return;
        }

        const newSocket = io(socketUrl, {
            transports: ['websocket'],
            withCredentials: true,
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            timeout: 20000,
            query: { 
                screen,
                monitorMode,
                userId: user?.id,
                userName: user?.name,
                tabId: TAB_ID,
                canSelectClients: user?.capabilities?.canSelectClients ? '1' : '0',
                clientsUserID: user?.clientsUserID ?? null
            },
        });

        console.log(screen, '🧩 setupSocket (tabId:', TAB_ID, ')');

        setSocket(newSocket);

        return () => {

            newSocket.disconnect();

            if (
                useSocketStore.getState().socket === newSocket
            ) {
                setSocket(null);
            }

        };

    }, [user]);

}